<template>
  <q-card
    @keydown="windowKeyDown"
    :style="'max-width: 250px; min-width: 250px;'"
  >
    <q-card-section class="q-py-xs q-pr-xs row">
      <div
        :class="[
          '',
          { 'text-grey-8': isPromtDialog },
          { 'text-subtitle2': !isPromtDialog },
        ]"
        style="max-width: calc(100% - 30px)"
      >
        {{ isPromtDialog ? msgText : headerText }}
      </div>
      <q-space />
      <q-btn
        size="sm"
        icon="close"
        class="q-my-none unset-items-center"
        flat
        round
        dense
        v-close-popup
      />
    </q-card-section>

    <q-separator />

    <q-card-section v-if="!isPromtDialog" class="scroll">
      <!-- Analytic Lists -->
      <div
        v-if="modelType === 5 && parameterMode === 1"
        :class="['cursor-pointer', 'q-my-none', 'q-pt-xs']"
      >
        <div class="justify-left full-width">
          <div
            class="items-center q-mr-sm q-my-auto"
            style="word-wrap: keep-all"
          >
            {{ $t("add_part") }}&nbsp;{{ totalElements }}&nbsp;{{
              $t("to_list_part")
            }}:
          </div>
          <div
            ref="listTriggerEl"
            class="items-center"
            style="word-wrap: break-word"
            :class="[
              'cursor-pointer',
              { 'text-grey-8': !listModel?.Entity?.Name },
            ]"
          >
            <div
              @click="listMenuModel = !listMenuModel"
              class="q-mt-sm"
            >
              {{ listModel?.Entity?.Name || $t("not_selected_label") }}
            </div>
          </div>
          <selector-popup
            v-model:visible="listMenuModel"
            :trigger-el="$refs.listTriggerEl"
            :default-width="300"
          >
            <aux-selector
              ref="aux_selector"
              :filter-model-value="aux_filter_string"
              @update:filter-model-value="(arg) => { aux_filter_string = arg; }"
              :model-value="[]"
              :show-search-header="true"
              @update:model-value="(arg) => { onUpdateListModel(arg); }"
              @input-value="(val) => { onUpdateListModelNew(val); }"
              :allow-free-input="true"
              :allow-multiple="true"
              :model-type="17"
              :limit-height-to-container="true"
              :exclude-id="srcElement.elType == 6 ? srcElement.Id : 0"
              :preferred-segment="srcElement.DestType"
              @selectorClosed="hideListMenu"
            />
          </selector-popup>
        </div>
      </div>

      <!-- Positions and movements comment edit -->
      <div v-if="modelType === 6" class="field-group">
        <q-select
          flat
          v-model="commentChangeType"
          class="thin-input q-mb-xs q-mr-xs"
          fill-input
          :bottom-slots="false"
          dense
          outlined
          :label-slot="false"
          hide-bottom-space
          :disable="parameterMode === 2"
          dropdown-icon="expand_more"
          option-value="Id"
          option-label="Name"
          input-debounce="500"
          :ref="'comment_type_select'"
          :options="changeCommentOptions"
        />
        <div class="flex items-end" style="flex-wrap: nowrap">
          <native-input
            ref="comment_field"
            style="width: -moz-available; width: -webkit-fill-available"
            :show-border="true"
            :model-value="innerNote"
            @update:caretPosition="onCaretPositionChange"
            @click="onNativeInputClick"
            @blur="onCommentBlur"
            @update:modelValue="
              (newname) => {
                innerNote = newname;
              }
            "
            :edit-on-click="true"
          />
          <q-btn
            @click.stop
            dense
            flat
            color="accent"
            size="11px"
            :icon="templateIconName"
            style="align-self: start"
            class="q-pa-none q-ml-sm"
          >
            <q-menu
              max-height="1300px"
              ref="comment_template_menu"
              anchor="center right"
              self="center left"
            >
              <aux-selector
                :model-type="parameterMode === 1 ? 24 : 25"
                :input-index="0"
                :allow-multiple="false"
                :allow-free-input="true"
                @deleteItem="deleteCommentTemplate"
                @update:caretPosition="onCaretPositionChange"
                v-model="comment_templates"
                @input-value="
                  (val) => {
                    addCommentTemplate(val);
                  }
                "
                @selectorClosed="
                  $refs.comment_template_menu &&
                  $refs.comment_template_menu.hide()
                "
              />
            </q-menu>
          </q-btn>
        </div>
      </div>

      <!-- tag statuses -->
      <q-select
        v-if="modelType === 1 && [1, 2].includes(parameterMode)"
        :label="$t('tags_upcase')"
        ref="tags_field"
        outlined
        v-model="tagsModel"
        use-input
        use-chips
        multiple
        autofocus
        option-label="Name"
        option-value="Id"
        @input-value="inputFilter"
        @new-value="addTextTag"
        input-debounce="100"
      >
        <q-menu fit no-focus v-model="selectorModel">
          <tag-selector
            v-if="modelType === 1"
            :filter_string="filter_string"
            v-model="tagsModel"
          />
        </q-menu>
      </q-select>

      <q-select
        style="min-width: 150px"
        autogrow
        autofocus
        outlined
        color="black"
        v-else-if="modelType === 1 && parameterMode === 3"
        input-debounce="500"
        fill-input
        v-model="tempTagStatus"
        no-error-icon
        :hint="$t('status_label')"
        :options="tagStatusOptions"
      />

      <q-btn
        class="q-my-none q-pa-none text-left"
        flat
        no-caps
        align="left"
        size="sm"
        dense
        color="grey-8"
        :label="parameterModelStr"
        :aria-label="$t('select_parameter')"
        v-else-if="modelType === 15 && parameterMode === 2"
      >
        <q-tooltip :delay="1000" anchor="top middle" self="center middle">
          {{ $t("select_parameter") }}
        </q-tooltip>
        <q-menu
          fit
          style="overflow: hidden"
          v-model="parameterSelectorModel"
          auto-close
          @before-show="(e) => { filter_string = '' }"
        >
          <div
            class="row justify-between q-mx-sm q-py-none no-wrap minw-selector"
          >
            <q-input
              outlined
              dense
              ref="panel_search_input"
              color="white"
              class="full-width thin-input q-my-auto"
              v-model="filter_string"
              hide-bottom-space
              :placeholder="$t('search_label')"
              autofocus
              debounce="100"
              @keydown.down.exact.prevent="
                $refs.rec_selector &&
                  ($refs.rec_selector).trackArrowDown(1)
              "
              @keydown.up.exact.prevent="
                $refs.rec_selector &&
                  ($refs.rec_selector).trackArrowUp(1)
              "
              @keyup.enter="
                $refs.rec_selector &&
                  ($refs.rec_selector).selectCurrent()
              "
            />

            <q-btn
              class="q-my-sm q-px-none q-mr-none q-ml-lg"
              flat
              dense
              :aria-label="$t('close_selector')"
              icon="close"
              size="md"
              @click.stop.prevent="parameterSelectorModel = false"
            >
              <q-tooltip :delay="1000">
                {{ $t("close_menu") }}
              </q-tooltip>
            </q-btn>
          </div>
          <q-separator class="q-my-none q-py-none" />
          <recursive-selector
            style="max-height: 50vh; overflow: auto"
            ref="rec_selector"
            :elements="parametersList"
            :take-ids-only="true"
            :show-records="true"
            :allow-multiple="false"
            :element-type="9"
            v-model="parametersModel"
            :hide-checkboxes="true"
            return-type="chain"
            nested-key-name="RecordFields"
            entity-inside-name="Template"
            :filter-out-list="[7]"
            :filter-string="filter_string"
          />
        </q-menu>
      </q-btn>

      <!-- parameter value editing fields -->

      <div v-if="modelType === 15 && parameterMode === 2 && parameterContainer">
        <div
          v-if="parameterContainer.IsList"
          class="row justify-between full-width left-panel"
        >
          <div class="col-10">
            {{ $t("list_param_values") }}
          </div>
          <q-btn
            class="q-my-none"
            flat
            dense
            round
            icon="add"
            size="sm"
            color="grey-8"
            @click="addParamRow"
            :aria-label="$t('add_list_element')"
          />
        </div>

        <div
          v-for="(param_row, param_index) in paramRows"
          :key="'pr_' + param_index"
          class="row full-width"
        >
          <div class="col">
            <multi-edit-line
              class="q-my-xs q-mr-xs"
              v-model="paramRows[param_index]"
              :parameter-value-type="parameterContainer.ValueType"
              :parameter-set-value-type="
                parameterContainer.ValueSet
                  ? parameterContainer.ValueSet.ValueType
                  : 0
              "
              :vset-type="vsetType"
              :vset-title="vsetTitle"
              :vsetOptions="vsetOptions"
            />
          </div>
          <q-btn
            v-if="parameterContainer.IsList"
            class="q-my-none"
            flat
            dense
            round
            icon="close"
            size="sm"
            color="grey-8"
            @click="deleteParamRow(param_index)"
            :aria-label="$t('delete_list_element')"
            tabindex="-1"
          />
        </div>
      </div>

      <q-select
        flat
        v-if="modelType === 15 && [1, 3].includes(parameterMode)"
        v-model="multipleParametersModel"
        fill-input
        multiple
        outlined
        dense
        use-chips
        option-label="Name"
        option-value="Id"
        input-debounce="500"
        :label="$t('select_parameters')"
      >
        <q-menu
          fit
          style="overflow: hidden"
          v-model="parameterSelectorModel"
          @before-show="(e) => { filter_string = '' }"
        >
          <div
            class="row justify-between q-mx-sm q-py-none no-wrap minw-selector"
          >
            <q-input
              outlined
              dense
              ref="panel_search_input"
              class="full-width thin-input q-my-auto"
              v-model="filter_string"
              hide-bottom-space
              :placeholder="$t('search_label')"
              autofocus
              debounce="100"
              @keydown.down.exact.prevent="
                $refs.rec_selector &&
                  ($refs.rec_selector).trackArrowDown(1)
              "
              @keydown.up.exact.prevent="
                $refs.rec_selector &&
                  ($refs.rec_selector).trackArrowUp(1)
              "
              @keyup.enter="
                $refs.rec_selector &&
                  ($refs.rec_selector).selectCurrent()
              "
            />

            <q-btn
              class="q-my-sm q-px-none q-mr-none q-ml-lg"
              flat
              dense
              :aria-label="$t('close_selector')"
              icon="close"
              size="md"
              @click.stop.prevent="parameterSelectorModel = false"
            >
              <q-tooltip :delay="1000">
                {{ $t("close_menu") }}
              </q-tooltip>
            </q-btn>
          </div>
          <q-separator class="q-my-none q-py-none" />
          <recursive-selector
            style="max-height: 50vh; overflow: auto"
            ref="rec_selector"
            :elements="parametersList"
            :take-ids-only="true"
            :show-records="false"
            :allow-multiple="true"
            :element-type="9"
            v-model="multipleParametersModelChains"
            :hide-checkboxes="false"
            return-type="chain"
            nested-key-name="RecordFields"
            entity-inside-name="Template"
            :filter-string="filter_string"
          />
        </q-menu>
      </q-select>

      <div
        v-if="msgText"
        style="word-wrap: break-word"
        class="q-mt-xs text-blue"
      >
        {{ msgText }}
      </div>
    </q-card-section>

    <q-separator />

    <q-card-actions align="right">
      <q-btn
        flat
        size="sm"
        :label="operation_passed ? $t('close_label') : $t('cancel')"
        ref="cancelbtn"
        color="dark"
        v-close-popup
      />
      <q-btn
        flat
        size="sm"
        :label="check_passed ? $t('continue') : headerText"
        ref="okbtn"
        color="dark"
        autofocus
        @click="performAction"
        v-if="!forbidden && !operation_passed"
      />
    </q-card-actions>
  </q-card>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
// import TagSelector from "@/components/common/aux-selector/TagSelector.vue";
import { CommonEntity } from "@/models/interfaces/common";
import RecursiveSelector from "@/components/common/basic/recursive-selector/refactored/RecursiveSelector.vue";
import {
  ParameterInstanceCreateContainer,
  ParameterTemplateForMultiEdit,
  ParameterValueSetDefaultHintContainer,
} from "@/models/interfaces/entity-settings/parameters/parameters";
import { multiEditStore } from "@/store/multiedit";
import { reactive } from "vue";
import {
  arrayEquals,
  findRecursive,
  trimEllip,
} from "@/models/helpers/recursive";
import { auxStore } from "@/store/auxillary";
import { TagContainer } from "@/models/interfaces/tags/tag-models";
import {
  BaseListItem,
  getIdentityKind,
} from "../common/base-list/interfaces/ListTypes";
import {
  PreCheckResult,
  V2ParameterValueSetExtensionType,
  V2ParameterValueSet_ValueType,
  V2ParameterValueType,
} from "@/models/etc/parameter-types";
import { findParametersByChain } from "@/utils/formulas";
import { ParamsRow } from "./MultiEditLine.vue";
import MultiEditLine from "./MultiEditLine.vue";
import { AnalyticsV2ElementType, TagType } from "@/models/etc/types";
import { i18n } from "@/i18n";
import { AnalyticsElementIdentity } from "@/models/interfaces/entity-settings/charts/charts";
import { SelectionEntityWithRolesFilterSend } from "@/models/interfaces/entity-settings/filters/filters";
import NativeInput from "../common/basic/NativeInput.vue";
import { StorageNoteTemplateDto } from "../../models/interfaces/storage/storage-models";
import { storagePositionsStore } from "../../store/storage/storage-positions";
import { storageMovementsStore } from "../../store/storage/storage-movements";
import { MultiEditStorageNoteEditType } from "../../store/interfaces/types.analytics";
import { formatLocalDateTimeAsPlus00 } from "../../utils/auxfunc";
import { BaseItemTypes } from "../dnd/ItemTypes";
import SelectorPopup from '@/components/common/aux-selector/SelectorPopup.vue';

@Component({
  name: "MultiEditDialog",
  components: {
    RecursiveSelector,
    MultiEditLine,
    NativeInput,
    SelectorPopup,
  },
})
export default class MultiEditDialog extends Vue {
  private templateIconUrl: string = require("@/assets/icon-comment.svg");
  // вычисляемое свойство, которое Quasar ожидает в виде строки "img:URL"
  get templateIconName(): string {
    return `img:${this.templateIconUrl}`;
  }

  // model data
  @Prop({ default: [] })
  entities!: number[];
  @Prop({ default: i18n.global.t("edit_entities") })
  headerText!: string;
  // 1 - add tags; 2 - parameters action; 3 - delete tags
  @Prop({ default: 1 })
  modelType!: number;
  @Prop({ default: undefined })
  srcElement!: BaseListItem;
  @Prop({ default: false })
  allChecked!: boolean;
  // 1 - add parameters; 2 - change parameter; 3 - delete parameters
  @Prop({ default: 1 })
  parameterMode!: number;
  @Prop({ default: 0 })
  totalElements!: number;
  @Emit("selectorClosed") emitSelectorClosed(arg: any) {
    return arg;
  }
  @Emit("refreshNeeded") emitTableRefresh(arg: any) {
    return arg;
  }

  // store for search functions
  auxstore: any | undefined = undefined;
  storage_pos: any | undefined = undefined;
  storage_move: any | undefined = undefined;
  filter_string: string = "";
  aux_filter_string: string = "";
  store: any | undefined = undefined;
  check_passed: boolean = false;
  operation_passed: boolean = false;

  // tags
  tags: any[] = [];
  system_tags: CommonEntity[] = [];
  parameterLink: any = { IdChain: [] };
  parameterByLink: any;

  tempTagStatus: any = undefined;
  listMenuModel: boolean = false;

  parameterContainer: ParameterInstanceCreateContainer | undefined = undefined;
  parametersList: ParameterInstanceCreateContainer[] = [];

  msgText: string = "";
  selectorModel: boolean = false;
  parameterSelectorModel: boolean = false;
  forbidden: boolean = false;

  // parameters
  paramRows: ParamsRow[] = reactive([]);
  vsetType?: V2ParameterValueSetExtensionType = undefined;
  vsetTitle?: string = "";
  vsetOptions: CommonEntity[] = reactive([] as CommonEntity[]);

  // comments
  commentChangeType: CommonEntity = {
    Name: i18n.global.t('replace'),
    Id: MultiEditStorageNoteEditType.Rewrite,
  }; // 0 - изменить; 1 - дописать
  innerNote: string = "";
  lastCommentCaretPosition: number = 0;
  comment_templates = reactive([]);
  private _blockCaretUpdate = false;

  tids: number[] = [];

  // rules
  intRules = [
    (val: any) => !this.isNumeric(val) || i18n.global.t("enter_integer"),
  ];
  floatRules = [
    (val: any) => !this.isNumericFloat(val) || i18n.global.t("input_float"),
  ];

  // analytics lists
  listMenu: any = undefined;
  listModel: SelectionEntityWithRolesFilterSend = {
    Entity: { Name: "", Id: 0 },
    Roles: [],
    Positive: true,
  };

  get isPromtDialog() {
    return (
      (this.modelType === 5 && this.parameterMode === 2) || this.modelType === 4
    );
  }

  windowKeyDown(e: KeyboardEvent) {
    if (e.key == "ArrowLeft") {
      setTimeout(() => {
        // @ts-ignore
        this.$refs.cancelbtn && this.$refs.cancelbtn.$el.focus();
      }, 100);
    } else if (e.key == "ArrowRight") {
      setTimeout(() => {
        // @ts-ignore
        this.$refs.okbtn && this.$refs.okbtn.$el.focus();
      }, 100);
    }
  }

  onCaretPositionChange(val: number) {
    if (val >= 0 && !this._blockCaretUpdate) {
      this.lastCommentCaretPosition = +val;
    }
  }

  // width function
  get changeCommentOptions() {
    return [
      {
        Name: this.$t('replace'),
        Id: MultiEditStorageNoteEditType.Rewrite,
      },
      {
        Name: this.$t('append'),
        Id: MultiEditStorageNoteEditType.Append,
      },
    ];
  }

  @Watch("comment_templates")
  comment_template_watcher() {
    if (!this.comment_templates.length) {
      return;
    }

    const templateText = (this.comment_templates[0] as StorageNoteTemplateDto).Text;
    this.tids.push((this.comment_templates[0] as StorageNoteTemplateDto).Id);

    const original = this.innerNote || "";

    let c_pos = this.lastCommentCaretPosition;
    if (c_pos < 0) {
      c_pos = 0;
    } else if (c_pos > original.length) {
      c_pos = original.length;
    }

    this._blockCaretUpdate = true;
    this.innerNote =
      original.slice(0, c_pos) + templateText + original.slice(c_pos);
    this.lastCommentCaretPosition = c_pos + templateText.length;
    this.comment_templates.splice(0);

    // @ts-ignore
    this.$refs.comment_template_menu && this.$refs.comment_template_menu.hide();
    this.$nextTick(() => {
      this._blockCaretUpdate = false;
    });
  }

  onCommentBlur() {
    this._blockCaretUpdate = true;
    setTimeout(() => {
      this._blockCaretUpdate = false;
    }, 0);
  }

  onNativeInputClick() {
    setTimeout(() => {
      // @ts-ignore
      const ref = this.$refs.comment_field as any;
      const field = ref?.$refs?.editable_field as HTMLElement | null;
      if (!field) return;
      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0) {
        const range = sel.getRangeAt(0);
        const pre = range.cloneRange();
        pre.selectNodeContents(field);
        pre.setEnd(range.endContainer, range.endOffset);
        this.lastCommentCaretPosition = pre.toString().length;
      }
    }, 0);
  }

  async addCommentTemplate(t_name: string) {
    if (t_name && t_name.length && this.innerNote && this.innerNote.length) {
      console.log("add new: " + t_name);
      if (this.parameterMode === 1) {
        // positions
        this.storage_pos.createNoteTemplate({
          Name: t_name,
          Text: this.innerNote,
        });
      } else if (this.parameterMode === 2) {
        this.storage_move.createMovementNoteTemplate({
          Name: t_name,
          Text: this.innerNote,
        });
      }
    }
  }

  async deleteCommentTemplate(t_id: number) {}

  // multiple parameters selection
  parametersMultipleValues: any[] = [];

  isNumeric(str: string) {
    if (typeof str != "string") return false; // we only process strings!
    return (
      !isNaN(+str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseInt(str))
    ); // ...and ensure strings of whitespace fail
  }

  isNumericFloat(str: string) {
    if (typeof str != "string") return false; // we only process strings!
    return (
      !isNaN(+str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str))
    ); // ...and ensure strings of whitespace fail
  }

  @Watch("filter_string")
  // change focus from search field to list when up and down arrow keys are pressed
  focusPanel() {
    const that = this;
    setTimeout(() => {
      that.$refs.rec_selector &&
        (that.$refs.rec_selector as any).trackArrowDown(1, true);
    }, 100);
  }

  async created() {
    this.store = multiEditStore();
    this.auxstore = auxStore();
    this.storage_pos = storagePositionsStore();
    this.storage_move = storageMovementsStore();

    this.paramRows = reactive([]);
    this.tids = [];

    if (this.auxstore && this.modelType != 5) {
      this.system_tags = reactive(
        (await this.auxstore.getTagContainer()).data as TagContainer,
      ).AllSystemTags;
    }
  }

  hideListMenu() {
    this.listMenuModel = false;
    setTimeout(() => {
      // @ts-ignore
      this.$refs.okbtn && this.$refs.okbtn.$el.focus();
    }, 50);
  }

  onUpdateListModel(arg: any) {
    arg && arg.length && (this.listModel = arg[0]);

    localStorage.setItem(
      "last_selected_anlist_" + this.srcElement.DestType,
      JSON.stringify(this.listModel.Entity),
    );
  }

  onUpdateListModelNew(arg: string) {
    this.listModel = {
      Entity: { Name: arg, Id: -1 },
      Roles: [],
      Positive: true,
    };

    localStorage.setItem(
      "last_selected_anlist_" + this.srcElement.DestType,
      JSON.stringify(this.listModel.Entity),
    );
  }

  // tags model
  get tagsModel(): any[] {
    return this.tags;
  }

  set tagsModel(val: any[]) {
    this.check_passed = false;
    this.tags = val;
    this.selectorModel = false;
  }

  // tag status flags filter
  tagStatusName(arg: number): string {
    switch (arg) {
      case TagType.Standard:
        return this.$t("normal_label");
      case TagType.Hidden:
        return this.$t("hidden_upcase");
      default:
        return this.$t("status_unknown");
    }
  }

  get tagStatusOptions() {
    return Object.values(TagType)
      .filter((v) => !isNaN(Number(v)) && Number(v) >= 0)
      .map((vm) => {
        return {
          label: this.tagStatusName(Number(vm)),
          value: Number(vm),
        };
      });
  }

  get tagStatusModel() {
    return this.tempTagStatus;
  }

  set tagStatusModel(arg: any) {
    this.tempTagStatus = arg;
  }

  // single
  get parametersModel(): any {
    return [this.parameterLink?.IdChain];
  }

  set parametersModel(val: any) {
    this.check_passed = false;
    if (this.parameterLink) {
      this.parameterSelectorModel = false;
      this.parameterLink = { IdChain: val[0] };
    }
  }

  addParamRow() {
    this.paramRows.push({
      stringValue: "",
      dateValueModel: "",
      checkBoxModel: false,
      // value set models
      vsetValues: [],
      dateValueSetModel: "",
    });
  }

  deleteParamRow(del_index: number) {
    this.paramRows.splice(del_index, 1);
  }

  // multiple
  get multipleParametersModelChains(): any {
    return this.parametersMultipleValues.map((el: any) => el.chain);
  }

  get multipleParametersModel(): any {
    return this.parametersMultipleValues;
  }

  set multipleParametersModel(val: any) {
    this.parametersMultipleValues = reactive(val);
  }

  set multipleParametersModelChains(val: any) {
    if (!val) {
      return;
    }
    this.check_passed = false;

    this.parametersMultipleValues = val.map((el: any) => {
      const found_element = findParametersByChain(
        el,
        this.parametersList,
        "RecordFields",
        "Template",
      );
      return {
        Id: found_element
          ? found_element.map((el: any) => el.Template.Id).join("_")
          : 0,
        Name: found_element
          ? found_element.map((el: any) => el.Template.Name).join(".")
          : "",
        chain: el,
      };
    });
  }

  @Watch("paramRows", { deep: true })
  params_watcher(arg: string) {
    this.check_passed = false;
  }

  @Watch("parameterContainer", { deep: true })
  async getVSetOptions() {
    this.vsetOptions = reactive([]);
    this.vsetType = undefined;
    this.vsetTitle = "";

    if (
      !this.store ||
      !this.parameterContainer ||
      !this.parameterContainer.ValueSet
    ) {
      return;
    }

    const res = await this.store.getValueSetHints(
      this.parameterContainer.ValueSet.Id,
    );

    res &&
      (this.vsetOptions = reactive(
        (res.data as ParameterValueSetDefaultHintContainer).DefaultHints.sort(
          (el1, el2) => el1.UsageCount - el2.UsageCount,
        ).map((el) => {
          return {
            Id: el.Id,
            Name: trimEllip(
              el.Name,
              (res.data as ParameterValueSetDefaultHintContainer)
                .HintsFieldLenght,
            ),
          };
        }),
      ));
    this.vsetType = (
      res.data as ParameterValueSetDefaultHintContainer
    ).HintedSetType;
    this.vsetTitle = (
      res.data as ParameterValueSetDefaultHintContainer
    ).HintedSetName;
  }

  @Watch("selectorModel")
  dialog_watcher(arg: boolean) {
    this.check_passed = false;
    if (!arg) {
      const that = this;
      setTimeout(() => {
        that.filter_string = "";
        // @ts-ignore
        that.$refs.tags_field.updateInputValue(this.filter_string, true);
      }, 100);
    }
  }

  inputFilter(val: string) {
    this.check_passed = false;
    if (val) {
      this.selectorModel = true;
      this.filter_string = val;
    } else {
      // if previous was just one letter then clear
      // if (this.filter_string.length === 1) {
      this.selectorModel = false;
      // } else {
      //   // else restore input value
      //   const that = this
      //   setTimeout(() => {
      //     if (!that.$refs.tags_field) { return }
      //     // @ts-ignore
      //     that.$refs.tags_field.updateInputValue(this.filter_string, true)
      //     // @ts-ignore
      //     that.$refs.tags_field.focus()
      //   }, 100)
      // }
    }
  }

  // precheck and perform
  performAction() {
    if (this.operation_passed) {
      return;
    }

    switch (this.modelType) {
      case 1:
        if (this.parameterMode === 1) {
          if (this.check_passed) {
            this.addTagsToEntities();
          } else {
            this.checkAddTagsToEntities();
          }
        } else if (this.parameterMode === 2) {
          if (this.check_passed) {
            this.deleteTagsFromEntities();
          } else {
            this.checkDeleteTagsFromEntities();
          }
        } else if (this.parameterMode === 3) {
          if (this.check_passed) {
            this.changeEntityTagsStatus();
          } else {
            this.checkEntityTagsStatus();
          }
        }
        break;
      case 5:
        if (this.parameterMode === 1) {
          this.addEntitiesToList();
        } else if (this.parameterMode === 2) {
          if (this.check_passed) {
            this.removeEntitiesFromList();
          } else {
            this.checkRemoveEntitiesFromList();
          }
        }
        break;
      case 4:
        if (this.check_passed) {
          this.removeEntities();
        } else {
          this.checkRemoveEntities();
        }
        break;
      case 15:
        if (this.parameterMode === 2) {
          if (this.check_passed || this.srcElement.DestType === 7) {
            this.changeEntitiesParameter();
          } else {
            this.checkChangeParameter();
          }
        } else if (this.parameterMode === 1) {
          if (this.check_passed) {
            this.addEntitiesParameters();
          } else {
            this.checkAddParameters();
          }
        } else if (this.parameterMode === 3) {
          if (this.check_passed) {
            this.deleteEntitiesParameters();
          } else {
            this.checkDeleteParameters();
          }
        }
        break;
      case 6:
        if (this.check_passed && [7,8].includes(this.srcElement.DestType)) {
          this.changeComment();
        }
        break;
      default:
        break;
    }
  }

  addTextTag(val: string, done: any) {
    this.check_passed = false;
    const found_el = this.system_tags.find((el) => el.Name.trim() === val);
    this.filter_string = "";
    if (found_el) {
      done(found_el, "add-unique");
    } else {
      done(val, "add-unique");
    }
  }

  // tags aactions
  checkAddTagsToEntities() {
    if (!this.tags || !this.tags.length) {
      return;
    }

    const text_array = this.tags.filter((el: any) => {
      return typeof el === "string";
    });
    const entity_array = this.tags.filter((el: any) => {
      return typeof el === "object";
    });

    this.msgText =
      this.$t("following_tags_will_be_added") +
      " " +
      [...entity_array.map((el) => el.Name), ...text_array].join(", ") +
      (this.allChecked
        ? this.$t("to_all_entityes") +
          (this.entities.length
            ? ", " + this.$t("except_label") + " " + this.entities.length
            : "")
        : " " + this.$t("to_entities_count") + " " + this.entities.length) +
      ". " +
      this.$t("press_label") +
      ' "' +
      this.$t("continue") +
      '"' +
      this.$t("to_perform");

    this.check_passed = true;
  }

  async addTagsToEntities() {
    if (!this.tags || !this.tags.length) {
      return;
    }

    const text_array = this.tags.filter((el: any) => {
      return typeof el === "string";
    });
    const entity_array = this.tags.filter((el: any) => {
      return typeof el === "object";
    });

    let request: any = {
      NewTags: text_array,
      TagIds: entity_array.map((el) => el.Id),
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
    };

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    console.log(request);
    await this.store.addTags(request);

    this.msgText = this.$t("action_done");
    this.check_passed = false;
    this.operation_passed = true;
    this.emitTableRefresh(true);
  }

  async changeComment() {
    let request: any = {
      ActionType: this.commentChangeType.Id,
      Note: this.innerNote,
      UsedNoteTemplateIds: this.tids,
      IssuedAt:
        this.commentChangeType.Id === MultiEditStorageNoteEditType.Append
          ? formatLocalDateTimeAsPlus00()
          : null,
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
    };

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6, 7, 8].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    if (this.parameterMode === 1) {
      await this.store.changeStorageItemsComment(request);
    } else if (this.parameterMode === 2) {
      await this.store.changeItemMovementsComment(request);
    }

    this.tids.splice(0);

    this.msgText = this.$t("action_done");
    this.check_passed = false;
    this.operation_passed = true;
    this.emitTableRefresh(true);
  }

  checkAddEntitiesToList() {
    if (!this.totalElements) {
      return;
    }

    if (this.listModel && this.listModel.Entity) {
      if (this.listModel.Entity.Id <= 0 && !this.listModel.Entity.Name.length) {
        this.msgText = this.$t("please_select_list");
        return;
      }
    } else {
      this.msgText = this.$t("please_select_list");
      return;
    }

    this.msgText =
      (this.allChecked
        ? this.$t("all_entities") +
          (this.entities.length
            ? this.$t("except_label") + " " + this.entities.length + ","
            : "") +
          " " +
          this.$t("will_be_added_to_list")
        : this.$t("following_entities_count") +
          " (" +
          this.entities.length +
          this.$t("pcs") +
          ") " +
          this.$t("will_be_added_to_list")) +
      ". " +
      this.$t("press_label") +
      ' "' +
      this.$t("continue") +
      '" ' +
      this.$t("to_perform");

    this.check_passed = true;
  }

  async addEntitiesToList() {
    if (this.listModel && this.listModel.Entity) {
      if (this.listModel.Entity.Id <= 0 && !this.listModel.Entity.Name.length) {
        this.msgText = this.$t("please_select_list");
        return;
      }
    } else {
      this.msgText = this.$t("please_select_list");
      return;
    }

    if (!this.listModel || !this.listModel.Entity || !this.totalElements) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
    };

    if (this.listModel.Entity.Id > 0) {
      request.ListId = this.listModel.Entity.Id;
    } else if (this.listModel.Entity.Name.length) {
      request.NewListName = this.listModel.Entity.Name;
    }

    request.Container.ElementIdentity = {
      ElementId: this.srcElement.Id,
      Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
        ? this.srcElement.SrcType
        : null,
      Destination: this.srcElement.DestType,
      Kind: getIdentityKind(this.srcElement),
    } as AnalyticsElementIdentity;

    await this.store.addEntitiesToList(request);

    /* this.msgText = this.$t('action_done');
      this.check_passed = false;
      this.operation_passed = true; */
    this.closeItemMenu();
  }

  checkRemoveEntitiesFromList() {
    if (!this.totalElements) {
      return;
    }

    this.msgText =
      (this.allChecked
        ? this.$t("all_entities") +
          (this.entities.length
            ? this.$t("except_label") + " " + this.entities.length + ","
            : "") +
          " " +
          this.$t("will_be_removed_from_list")
        : this.$t("following_entities_count") +
          " (" +
          this.entities.length +
          this.$t("pcs") +
          ") " +
          this.$t("will_be_removed_from_list")) +
      ". " +
      this.$t("press_label") +
      ' "' +
      this.$t("continue") +
      '" ' +
      this.$t("to_perform");

    this.check_passed = true;
  }

  async removeEntitiesFromList() {
    if (!this.totalElements) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
    };

    request.Container.ElementIdentity = {
      ElementId: this.srcElement.Id,
      Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
        ? this.srcElement.SrcType
        : null,
      Destination: this.srcElement.DestType,
      Kind: getIdentityKind(this.srcElement),
    } as AnalyticsElementIdentity;

    await this.store.deleteEntitiesFromList(request);

    /* this.msgText = this.$t('action_done');
      this.check_passed = false;
      this.operation_passed = true;
      */
    this.emitTableRefresh(true);
    this.closeItemMenu();
  }

  checkRemoveEntities() {
    if (!this.allChecked && (!this.entities || !this.entities.length)) {
      return;
    }

    // this.msgText = this.$t('will_be_removed')+
    // (this.allChecked ? ' '+this.$t('all_entities') + (this.entities.length ? ', '+this.$t('except_label')+' '+this.entities.length : '') :
    // ' '+this.$t('following_entities_count')+' '+this.entities.length+' '+this.$t('pcs'))+
    // '. '+this.$t('press_label')+' "'+this.$t('continue')+'"'+this.$t('to_perform');

    this.msgText =
      (this.allChecked
        ? this.$t("all_entities") +
          (this.entities.length
            ? this.$t("except_label") + " " + this.entities.length + ","
            : "") +
          " " +
          this.$t("will_be_removed")
        : this.$t("following_entities_count") +
          " (" +
          this.entities.length +
          this.$t("pcs") +
          ") " +
          this.$t("will_be_removed")) +
      " " +
      this.$t("not_only_selection") +
      ". " +
      this.$t("press_label") +
      ' "' +
      this.$t("continue") +
      '" ' +
      this.$t("to_perform");

    this.check_passed = true;
  }

  async removeEntities() {
    if (!this.allChecked && (!this.entities || !this.entities.length)) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
    };

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    console.log(request.Container);
    await this.store.removeEntities(request.Container);

    this.msgText = this.$t("action_done");
    this.check_passed = false;
    this.operation_passed = true;
    this.emitTableRefresh(true);
  }

  // tag entities status change
  checkEntityTagsStatus() {
    if (!this.allChecked && (!this.entities || !this.entities.length)) {
      return;
    }

    if (!this.tempTagStatus) {
      this.msgText = this.$t("status_needed");
    } else {
      this.msgText =
        this.$t("status_will_be_modified") +
        (this.allChecked
          ? " " +
            this.$t("on_all_tags") +
            (this.entities.length
              ? ", " + this.$t("except_label") + " " + this.entities.length
              : "")
          : " " +
            this.$t("on_tags_count") +
            " " +
            this.entities.length +
            " " +
            this.$t("pcs")) +
        ". " +
        this.$t("press_label") +
        ' "' +
        this.$t("continue") +
        '"' +
        this.$t("to_perform");
    }
    this.check_passed = true;
  }

  async changeEntityTagsStatus() {
    if (!this.allChecked && (!this.entities || !this.entities.length)) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
      NewStatus: this.tempTagStatus.value,
    };

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    console.log(request);
    await this.store.changeTagsStatus(request);

    this.msgText = this.$t("action_done");
    this.check_passed = false;
    this.operation_passed = true;
    this.emitTableRefresh(true);
  }

  checkDeleteTagsFromEntities() {
    if (!this.tags || !this.tags.length) {
      return;
    }

    const text_array = this.tags.filter((el: any) => {
      return typeof el === "string";
    });
    const entity_array = this.tags.filter((el: any) => {
      return typeof el === "object";
    });

    this.msgText =
      this.$t("following_tags_will_be_removed") +
      " " +
      [...entity_array.map((el) => el.Name), ...text_array].join(", ") +
      (this.allChecked
        ? " " +
          this.$t("from_all_entities") +
          (this.entities.length
            ? ", " + this.$t("except_label") + " " + this.entities.length
            : "")
        : " " + this.$t("from_entities_count") + " " + this.entities.length) +
      ". " +
      this.$t("press_label") +
      ' "' +
      this.$t("continue") +
      '"' +
      this.$t("to_perform");

    this.check_passed = true;
  }

  async deleteTagsFromEntities() {
    if (!this.tags || !this.tags.length) {
      return;
    }

    const text_array = this.tags.filter((el: any) => {
      return typeof el === "string";
    });
    const entity_array = this.tags.filter((el: any) => {
      return typeof el === "object";
    });

    let request: any = {
      NewTags: text_array,
      TagIds: entity_array.map((el) => el.Id),
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
    };

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    console.log(request);
    await this.store.deleteTags(request);

    this.msgText = this.$t("action_done");
    this.check_passed = false;
    this.operation_passed = true;
    this.emitTableRefresh(true);
  }

  // parameters actions
  async checkChangeParameter() {
    if (
      !this.parameterContainer ||
      !this.parameterLink ||
      !this.parameterLink.IdChain ||
      !this.parameterLink.IdChain.length
    ) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
      ParameterLink: this.parameterLink,
    };

    request.InstanceValues = this.paramRows
      .filter(
        (el) =>
          this.parameterContainer?.ValueType !==
            V2ParameterValueType.ValueSet ||
          !el.vsetValues ||
          !el.vsetValues.length,
      )
      .map((row: ParamsRow) => {
        switch (this.parameterContainer?.ValueType) {
          case V2ParameterValueType.String:
            return {
              StringValue: row.stringValue || null,
            };
          case V2ParameterValueType.Int:
            return {
              NumberValue: this.isNumeric(row.stringValue)
                ? +row.stringValue
                : null,
            };
          case V2ParameterValueType.Double:
            return {
              NumberValue: this.isNumericFloat(row.stringValue)
                ? +row.stringValue
                : null,
            };
          case V2ParameterValueType.Bool:
            return {
              BoolValue: row.checkBoxModel,
            };
          case V2ParameterValueType.Date:
            return {
              DateValue: row.dateValueModel || null,
            };
          case V2ParameterValueType.ValueSet:
            if (!row.vsetValues.new) {
              return {
                SelectedValueId: row.vsetValues.Id || null,
              };
            } else {
              switch (this.parameterContainer.ValueSet.ValueType) {
                case V2ParameterValueSet_ValueType.String:
                  return {
                    NewCreatedValue: {
                      NameString: row.vsetValues.NameString,
                    },
                  };
                // falls through
                case V2ParameterValueSet_ValueType.Int:
                case V2ParameterValueSet_ValueType.Decimal:
                  return {
                    NewCreatedValue: {
                      NameNumber: row.vsetValues.NameNumber,
                    },
                  };
                case V2ParameterValueSet_ValueType.Date:
                  return {
                    NewCreatedValue: {
                      NameDate: row.vsetValues.NameDate,
                    },
                  };
                default:
                  return null;
              }
            }
          default:
            return null;
        }
      })
      .filter((el) => el !== null);

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    console.log(request);

    const res = await this.store.preCheckParametersAccess(request.Container);
    if (res?.data?.Result === PreCheckResult.ActionAllowedCompletely) {
      this.msgText =
        this.$t("parameter_will_be_changed") +
        " " +
        (this.allChecked
          ? this.$t("to_all_entityes") +
            (this.entities.length
              ? ", " + this.$t("except_label") + " " + this.entities.length
              : "")
          : " " + this.$t("to_entities_count") + " " + this.entities.length) +
        ". " +
        this.$t("press_label") +
        ' "' +
        this.$t("continue") +
        '"' +
        this.$t("to_perform");

      this.check_passed = true;
    } else if (res?.data?.Result === PreCheckResult.ActionAllowedPartially) {
      this.msgText =
        this.$t("not_all_allowed") +
        " (" +
        res.data.ForbiddenEntitiesCount +
        " " +
        this.$t("forbidden_label") +
        ", " +
        res.data.AllowedEntitiesCount +
        " " +
        this.$t("allowed_label") +
        "). " +
        this.$t("press_label") +
        ' "' +
        this.$t("continue") +
        '"' +
        this.$t("to_perform");

      this.check_passed = true;
    }
  }

  async changeEntitiesParameter() {
    if (
      !this.parameterContainer ||
      !this.parameterLink ||
      !this.parameterLink.IdChain ||
      !this.parameterLink.IdChain.length
    ) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
      ParameterLink: this.parameterLink,
    };

    request.InstanceValues = this.paramRows
      .filter(
        (el) =>
          this.parameterContainer?.ValueType !==
            V2ParameterValueType.ValueSet ||
          !el.vsetValues ||
          !el.vsetValues.length,
      )
      .map((row: ParamsRow) => {
        switch (this.parameterContainer?.ValueType) {
          case V2ParameterValueType.String:
            return {
              StringValue: row.stringValue || null,
            };
          case V2ParameterValueType.Int:
            return {
              NumberValue: this.isNumeric(row.stringValue)
                ? +row.stringValue
                : null,
            };
          case V2ParameterValueType.Double:
            return {
              NumberValue: this.isNumericFloat(row.stringValue)
                ? +row.stringValue
                : null,
            };
          case V2ParameterValueType.Bool:
            return {
              BoolValue: row.checkBoxModel,
            };
          case V2ParameterValueType.Date:
            return {
              DateValue: row.dateValueModel || null,
            };
          case V2ParameterValueType.ValueSet:
            if (!row.vsetValues.new) {
              return {
                SelectedValueId: row.vsetValues.Id || null,
              };
            } else {
              switch (this.parameterContainer.ValueSet.ValueType) {
                case V2ParameterValueSet_ValueType.String:
                  return {
                    NewCreatedValue: {
                      NameString: row.vsetValues.NameString,
                    },
                  };
                // falls through
                case V2ParameterValueSet_ValueType.Int:
                case V2ParameterValueSet_ValueType.Decimal:
                  return {
                    NewCreatedValue: {
                      NameNumber: row.vsetValues.NameNumber,
                    },
                  };
                case V2ParameterValueSet_ValueType.Date:
                  return {
                    NewCreatedValue: {
                      NameDate: row.vsetValues.NameDate,
                    },
                  };
                default:
                  return null;
              }
            }
          default:
            return null;
        }
      })
      .filter((el) => el !== null);

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6, 7].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    await this.store.editParameters(request);

    this.msgText = this.$t("action_done");
    this.check_passed = false;
    this.operation_passed = true;
    this.emitTableRefresh(true);
  }

  async addEntitiesParameters() {
    if (!this.multipleParametersModel || !this.multipleParametersModel.length) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
      ParameterTemplateIds: this.multipleParametersModel.map((el: any) => {
        return el.Id;
      }),
    };

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    await this.store.addParameters(request);

    this.msgText = this.$t("action_done");
    this.check_passed = false;
    this.operation_passed = true;
    this.emitTableRefresh(true);
  }

  async checkAddParameters() {
    if (!this.multipleParametersModel || !this.multipleParametersModel.length) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
      ParameterTemplateIds: this.multipleParametersModel.map((el: any) => {
        return el.Id;
      }),
    };

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    console.log(request);

    const res = await this.store.preCheckParametersAccess(request.Container);
    if (res?.data?.Result === PreCheckResult.ActionAllowedCompletely) {
      this.msgText =
        this.$t("parameters_will_be_added") +
        " " +
        (this.allChecked
          ? this.$t("to_all_entityes") +
            (this.entities.length
              ? ", " + this.$t("except_label") + " " + this.entities.length
              : "")
          : " " + this.$t("to_entities_count") + " " + this.entities.length) +
        ". " +
        this.$t("press_label") +
        ' "' +
        this.$t("continue") +
        '"' +
        this.$t("to_perform");

      this.check_passed = true;
    } else if (res?.data?.Result === PreCheckResult.ActionAllowedPartially) {
      this.msgText =
        this.$t("not_all_allowed") +
        " (" +
        res.data.ForbiddenEntitiesCount +
        " " +
        this.$t("forbidden_label") +
        ", " +
        res.data.AllowedEntitiesCount +
        " " +
        this.$t("allowed_label") +
        "). " +
        this.$t("press_label") +
        ' "' +
        this.$t("continue") +
        '"' +
        this.$t("to_perform");

      this.check_passed = true;
    }
  }

  async deleteEntitiesParameters() {
    if (!this.multipleParametersModel || !this.multipleParametersModel.length) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
      ParameterTemplateIds: this.multipleParametersModel.map((el: any) => {
        return el.Id;
      }),
    };

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    await this.store.deleteParameters(request);

    this.msgText = this.$t("action_done");
    this.check_passed = false;
    this.operation_passed = true;
    this.emitTableRefresh(true);
  }

  async checkDeleteParameters() {
    if (!this.multipleParametersModel || !this.multipleParametersModel.length) {
      return;
    }

    let request: any = {
      Container: {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      },
      ParameterTemplateIds: this.multipleParametersModel.map((el: any) => {
        return el.Id;
      }),
    };

    if (this.allChecked) {
      request.Container.ElementIdentity = {
        ElementId: this.srcElement.Id,
        Source: [0, 1, 2, 3, 4, 5, 6].includes(this.srcElement.SrcType)
          ? this.srcElement.SrcType
          : null,
        Destination: this.srcElement.DestType,
        Kind: getIdentityKind(this.srcElement),
      } as AnalyticsElementIdentity;
    }

    console.log(request);

    const res = await this.store.preCheckParametersAccess(request.Container);
    if (res?.data?.Result === PreCheckResult.ActionAllowedCompletely) {
      this.msgText =
        this.$t("parameters_will_be_removed") +
        " " +
        (this.allChecked
          ? " " +
            this.$t("from_all_entities") +
            (this.entities.length
              ? ", " + this.$t("except_label") + " " + this.entities.length
              : "")
          : " " + this.$t("from_entities_count") + " " + this.entities.length) +
        ". " +
        this.$t("press_label") +
        ' "' +
        this.$t("continue") +
        '"' +
        this.$t("to_perform");

      this.check_passed = true;
    } else if (res?.data?.Result === PreCheckResult.ActionAllowedPartially) {
      this.msgText =
        this.$t("not_all_allowed") +
        " (" +
        res.data.ForbiddenEntitiesCount +
        " " +
        this.$t("forbidden_label") +
        ", " +
        res.data.AllowedEntitiesCount +
        " " +
        this.$t("allowed_label") +
        "). " +
        this.$t("press_label") +
        ' "' +
        this.$t("continue") +
        '"' +
        this.$t("to_perform");

      this.check_passed = true;
    }
  }

  // display selected parameter name
  get parameterModelStr(): string {
    if (
      !this.parameterLink ||
      !this.parameterLink.IdChain ||
      !this.parameterLink.IdChain.length
    ) {
      return this.$t("no_parameter_selected");
    }

    let fullName = "";
    const param = findRecursive(
      function a(element: any, el_to_find: any): any | undefined {
        if (!element) return undefined;

        if (
          arrayEquals(
            [...el_to_find.chain, element.Template.Id],
            el_to_find.el_to_find,
          )
        ) {
          fullName = el_to_find.compound_name
            ? el_to_find.compound_name + "." + element.Template.Name
            : element.Template.Name;
          return element;
        }
        if (element.RecordFields) {
          return findRecursive(
            a,
            {
              chain: [...el_to_find.chain, element.Template.Id],
              compound_name: el_to_find.compound_name
                ? el_to_find.compound_name + "." + element.Template.Name
                : element.Template.Name,
              el_to_find: el_to_find.el_to_find,
            },
            element.RecordFields,
          );
        }
        return undefined;
      },
      { chain: [], compound_name: "", el_to_find: this.parameterLink.IdChain },
      this.parametersList,
    );
    this.parameterContainer = param;

    // add just one line if not list
    if (param && !param.IsList) {
      this.paramRows = reactive([
        {
          stringValue: "",
          dateValueModel: "",
          checkBoxModel: false,
          // value set models
          vsetValues: [],
          dateValueSetModel: "",
        },
      ]);
    }

    return param ? fullName : this.$t("no_parameter_selected");
  }

  async mounted() {
    if (this.modelType === 5) {
      if (this.parameterMode === 2) {
        this.checkRemoveEntitiesFromList();
      } else if (this.parameterMode === 1) {
        this.check_passed = true;

        // auto recall last remembered element if there is any
        const lastItemStr = localStorage.getItem(
          "last_selected_anlist_" + this.srcElement.DestType,
        );
        let lastItem = lastItemStr
          ? (JSON.parse(lastItemStr) as CommonEntity)
          : { Id: -1, Name: "" };
        if (lastItem && lastItem.Name) {
          // if any
          // find it
          const lists = (
            await this.auxstore.getFilterLists(
              lastItem.Name,
              10,
              0,
              this.srcElement.elType == BaseItemTypes.LIST ? this.srcElement.Id : 0,
              this.srcElement.DestType,
            )
          ).data.Lists;

          const foundEl = lists.find((el: any) => el.Name == lastItem.Name);
          if (foundEl) {
            this.listModel = {
              Entity: foundEl,
              Roles: [],
              Positive: true,
            };
            console.log(foundEl);
          }
          // in case there was a newly created item with Name and no Id
          localStorage.setItem(
            "last_selected_anlist_" + this.srcElement.DestType,
            JSON.stringify(this.listModel.Entity),
          );
        } else {
          const lists = (
            await this.auxstore.getFilterLists(
              "",
              1,
              0,
              this.srcElement.elType == BaseItemTypes.LIST ? this.srcElement.Id : 0,
              this.srcElement.DestType,
            )
          ).data.Lists;
          if (lists.length) {
            this.listModel = {
              Entity: lists[0],
              Roles: [],
              Positive: true,
            };
          }
          console.log(lists[0]);
          // in case there was a newly created item with Name and no Id
          localStorage.setItem(
            "last_selected_anlist_" + this.srcElement.DestType,
            JSON.stringify(this.listModel.Entity),
          );
        }
      }
    } else if (this.modelType === 6) {
      this.check_passed = true;

      this.commentChangeType = {
        Name: this.$t('append'),
        Id: MultiEditStorageNoteEditType.Append,
      }; // 0 - изменить; 1 - дописать
    } else {
      let request: any = {
        EntityIds: this.entities,
        TakeAnything: this.allChecked,
        Segment: this.srcElement.DestType,
      };
      if (this.allChecked) {
        request.ElementIdentity = {
          ElementId: this.srcElement.Id,
          Source: [0, 1, 2, 3, 4, 5, 6, 7].includes(this.srcElement.SrcType)
            ? this.srcElement.SrcType
            : null,
          Destination: this.srcElement.DestType,
          Kind: getIdentityKind(this.srcElement),
        } as AnalyticsElementIdentity;
      }

      if (this.modelType === 15 && this.srcElement.DestType != 7) {
        const res = await this.store.preCheckParametersAccess(request);
        if (res?.data?.Result === PreCheckResult.ActionForbidden) {
          this.msgText = this.$t("no_rights_edit_parameters");
          this.forbidden = true;
        } else {
          this.loadParametersTemplate();
        }
      } else if (this.modelType === 15 && this.srcElement.DestType === 7) {
        this.loadParametersTemplate();
      } else if (this.modelType === 4) {
        const res = await this.store.preCheckRemoveAccess(request);
        if (res?.data?.Result === PreCheckResult.ActionForbidden) {
          this.msgText = this.$t("no_rights_delete");
          this.forbidden = true;
        } else {
          this.checkRemoveEntities();
        }
      }
    }
  }

  async loadParametersTemplate() {
    if (!this.store) {
      return;
    }

    const response = await this.store.getParametersContainer(this.srcElement?.DestType);
    const templates = (response?.data || []) as ParameterTemplateForMultiEdit[];
    this.parametersList = reactive(
      templates
        .filter((el: ParameterTemplateForMultiEdit) => ![1, 3].includes(this.parameterMode) || !el.IsMandatory)
        .map((el: ParameterTemplateForMultiEdit) => el.TemplateContainer),
    );
  }

  closeItemMenu() {
    this.emitSelectorClosed(0);
  }
}
</script>

<style lang="scss">
.minw-selector {
  font-size: small !important;
  min-width: fit-content;
}
</style>
